"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _variables = require("../common/variables.js");

var _uuid = require("uuid");

var _utils = require("../common/utils.js");

var _Icons = _interopRequireDefault(require("./Icons"));

var _Listbox = _interopRequireDefault(require("./Listbox"));

var Popover = _interopRequireWildcard(require("@radix-ui/react-popover"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var groupsHaveOptions = function groupsHaveOptions(innerOptions) {
  return innerOptions[0].hasOwnProperty("options") ? innerOptions[0].options ? innerOptions.some(function (groupOption) {
    return groupOption.options.length > 0;
  }) : false : true;
};

var filteredGroupsHaveOptions = function filteredGroupsHaveOptions(filteredOptions) {
  return filteredOptions !== null && filteredOptions !== void 0 && filteredOptions[0].options ? filteredOptions.some(function (groupOption) {
    var _groupOption$options;

    return ((_groupOption$options = groupOption.options) === null || _groupOption$options === void 0 ? void 0 : _groupOption$options.length) > 0;
  }) : true;
};

var canOpenOptions = function canOpenOptions(options, disabled) {
  return !disabled && (options === null || options === void 0 ? void 0 : options.length) > 0 && groupsHaveOptions(options);
};

var filterOptionsBySearchValue = function filterOptionsBySearchValue(options, searchValue) {
  if ((options === null || options === void 0 ? void 0 : options.length) > 0) {
    if (options[0].options) return options.map(function (optionGroup) {
      var group = {
        label: optionGroup.label,
        options: optionGroup.options.filter(function (option) {
          return option.label.toUpperCase().includes(searchValue.toUpperCase());
        })
      };
      return group;
    });else return options.filter(function (option) {
      return option.label.toUpperCase().includes(searchValue.toUpperCase());
    });
  }
};

var getLastOptionIndex = function getLastOptionIndex(options, filteredOptions, searchable, optional, multiple) {
  var last = 0;

  var reducer = function reducer(acc, current) {
    var _current$options;

    return acc + ((_current$options = current.options) === null || _current$options === void 0 ? void 0 : _current$options.length);
  };

  if (searchable && filteredOptions.length > 0) filteredOptions[0].options ? last = filteredOptions.reduce(reducer, 0) - 1 : last = filteredOptions.length - 1;else if ((options === null || options === void 0 ? void 0 : options.length) > 0) options[0].options ? last = options.reduce(reducer, 0) - 1 : last = options.length - 1;
  return optional && !multiple ? last + 1 : last;
};

var getSelectedOption = function getSelectedOption(value, options, multiple, optional, optionalItem) {
  var selectedOption = multiple ? [] : {};
  var singleSelectionIndex;

  if (multiple) {
    if ((options === null || options === void 0 ? void 0 : options.length) > 0) {
      options.forEach(function (option) {
        if (option.options) {
          option.options.forEach(function (singleOption) {
            if (value.includes(singleOption.value)) selectedOption.push(singleOption);
          });
        } else if (value.includes(option.value)) selectedOption.push(option);
      });
    }
  } else {
    if (optional && value === "") {
      selectedOption = optionalItem;
      singleSelectionIndex = 0;
    } else if ((options === null || options === void 0 ? void 0 : options.length) > 0) {
      var group_index = 0;
      options.some(function (option, index) {
        if (option.options) {
          option.options.some(function (singleOption) {
            if (singleOption.value === value) {
              selectedOption = singleOption;
              singleSelectionIndex = optional ? group_index + 1 : group_index;
              return true;
            }

            group_index++;
          });
        } else if (option.value === value) {
          selectedOption = option;
          singleSelectionIndex = optional ? index + 1 : index;
          return true;
        }
      });
    }
  }

  return {
    selectedOption: selectedOption,
    singleSelectionIndex: singleSelectionIndex
  };
};

var notOptionalCheck = function notOptionalCheck(value, multiple, optional) {
  return !optional && (multiple ? value.length === 0 : value === "");
};

var DxcSelect = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _selectedOption$label;

  var label = _ref.label,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      options = _ref.options,
      helperText = _ref.helperText,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$optional = _ref.optional,
      optional = _ref$optional === void 0 ? false : _ref$optional,
      _ref$searchable = _ref.searchable,
      searchable = _ref$searchable === void 0 ? false : _ref$searchable,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      error = _ref.error,
      margin = _ref.margin,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _useState = (0, _react.useState)("select-".concat((0, _uuid.v4)())),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
      selectId = _useState2[0];

  var selectLabelId = "label-".concat(selectId);
  var errorId = "error-".concat(selectId);
  var optionsListId = "".concat(selectId, "-listbox");

  var _useState3 = (0, _react.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : multiple ? [] : ""),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      innerValue = _useState4[0],
      setInnerValue = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      searchValue = _useState6[0],
      setSearchValue = _useState6[1];

  var _useState7 = (0, _react.useState)(-1),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      visualFocusIndex = _useState8[0],
      changeVisualFocusIndex = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      isOpen = _useState10[0],
      changeIsOpen = _useState10[1];

  var selectRef = (0, _react.useRef)(null);
  var selectSearchInputRef = (0, _react.useRef)(null);
  var colorsTheme = (0, _useTheme["default"])();
  var translatedLabels = (0, _useTranslatedLabels["default"])();
  var optionalItem = {
    label: placeholder,
    value: ""
  };
  var filteredOptions = (0, _react.useMemo)(function () {
    return filterOptionsBySearchValue(options, searchValue);
  }, [options, searchValue]);
  var lastOptionIndex = (0, _react.useMemo)(function () {
    return getLastOptionIndex(options, filteredOptions, searchable, optional, multiple);
  }, [options, filteredOptions, searchable, optional, multiple]);

  var _useMemo = (0, _react.useMemo)(function () {
    return getSelectedOption(value !== null && value !== void 0 ? value : innerValue, options, multiple, optional, optionalItem);
  }, [value, innerValue, options, multiple, optional, optionalItem]),
      selectedOption = _useMemo.selectedOption,
      singleSelectionIndex = _useMemo.singleSelectionIndex;

  var openOptions = function openOptions() {
    if (!isOpen && canOpenOptions(options, disabled)) changeIsOpen(true);
  };

  var closeOptions = function closeOptions() {
    if (isOpen) {
      changeIsOpen(false);
      changeVisualFocusIndex(-1);
    }
  };

  var handleSelectChangeValue = function handleSelectChangeValue(newOption) {
    var newValue;

    if (multiple) {
      if ((value !== null && value !== void 0 ? value : innerValue).includes(newOption.value)) newValue = (value !== null && value !== void 0 ? value : innerValue).filter(function (optionVal) {
        return optionVal !== newOption.value;
      });else newValue = [].concat((0, _toConsumableArray2["default"])(value !== null && value !== void 0 ? value : innerValue), [newOption.value]);
    } else newValue = newOption.value;

    value !== null && value !== void 0 ? value : setInnerValue(newValue);
    notOptionalCheck(newValue, multiple, optional) ? onChange === null || onChange === void 0 ? void 0 : onChange({
      value: newValue,
      error: translatedLabels.formFields.requiredValueErrorMessage
    }) : onChange === null || onChange === void 0 ? void 0 : onChange({
      value: newValue
    });
  };

  var handleSelectOnClick = function handleSelectOnClick() {
    searchable && selectSearchInputRef.current.focus();

    if (isOpen) {
      closeOptions();
      setSearchValue("");
    } else openOptions();
  };

  var handleSelectOnFocus = function handleSelectOnFocus(event) {
    if (!event.currentTarget.contains(event.relatedTarget)) searchable && selectSearchInputRef.current.focus();
  };

  var handleSelectOnBlur = function handleSelectOnBlur(event) {
    // focus leaves container (outside, not to childs)
    if (!event.currentTarget.contains(event.relatedTarget)) {
      closeOptions();
      setSearchValue("");
      var currentValue = value !== null && value !== void 0 ? value : innerValue;
      notOptionalCheck(currentValue, multiple, optional) ? onBlur === null || onBlur === void 0 ? void 0 : onBlur({
        value: currentValue,
        error: translatedLabels.formFields.requiredValueErrorMessage
      }) : onBlur === null || onBlur === void 0 ? void 0 : onBlur({
        value: currentValue
      });
    }
  };

  var handleSelectOnKeyDown = function handleSelectOnKeyDown(event) {
    switch (event.key) {
      case "Down":
      case "ArrowDown":
        event.preventDefault();
        singleSelectionIndex !== undefined && (!isOpen || visualFocusIndex === -1 && singleSelectionIndex > -1 && singleSelectionIndex <= lastOptionIndex) ? changeVisualFocusIndex(singleSelectionIndex) : changeVisualFocusIndex(function (visualFocusIndex) {
          if (visualFocusIndex < lastOptionIndex) return visualFocusIndex + 1;else if (visualFocusIndex === lastOptionIndex) return 0;
        });
        openOptions();
        break;

      case "Up":
      case "ArrowUp":
        event.preventDefault();
        singleSelectionIndex !== undefined && (!isOpen || visualFocusIndex === -1 && singleSelectionIndex > -1 && singleSelectionIndex <= lastOptionIndex) ? changeVisualFocusIndex(singleSelectionIndex) : changeVisualFocusIndex(function (visualFocusIndex) {
          return visualFocusIndex === 0 || visualFocusIndex === -1 ? lastOptionIndex : visualFocusIndex - 1;
        });
        openOptions();
        break;

      case "Esc":
      case "Escape":
        event.preventDefault();
        closeOptions();
        setSearchValue("");
        break;

      case "Enter":
        if (isOpen && visualFocusIndex >= 0) {
          var accLength = optional && !multiple ? 1 : 0;

          if (searchable) {
            if (filteredOptions.length > 0) {
              if (optional && !multiple && visualFocusIndex === 0 && filteredGroupsHaveOptions(filteredOptions)) handleSelectChangeValue(optionalItem);else filteredOptions[0].options ? filteredGroupsHaveOptions(filteredOptions) && filteredOptions.some(function (groupOption) {
                var groupLength = accLength + groupOption.options.length;
                groupLength > visualFocusIndex && handleSelectChangeValue(groupOption.options[visualFocusIndex - accLength]);
                accLength = groupLength;
                return groupLength > visualFocusIndex;
              }) : handleSelectChangeValue(filteredOptions[visualFocusIndex - accLength]);
            }
          } else {
            if (optional && !multiple && visualFocusIndex === 0) handleSelectChangeValue(optionalItem);else options[0].options ? options.some(function (groupOption) {
              var groupLength = accLength + groupOption.options.length;
              groupLength > visualFocusIndex && handleSelectChangeValue(groupOption.options[visualFocusIndex - accLength]);
              accLength = groupLength;
              return groupLength > visualFocusIndex;
            }) : handleSelectChangeValue(options[visualFocusIndex - accLength]);
          }

          !multiple && closeOptions();
          setSearchValue("");
        }

        break;
    }
  };

  var handleSearchIOnChange = function handleSearchIOnChange(event) {
    setSearchValue(event.target.value);
    changeVisualFocusIndex(-1);
    openOptions();
  };

  var handleClearOptionsActionOnClick = function handleClearOptionsActionOnClick(event) {
    event.stopPropagation();
    value !== null && value !== void 0 ? value : setInnerValue([]);
    !optional ? onChange === null || onChange === void 0 ? void 0 : onChange({
      value: [],
      error: translatedLabels.formFields.requiredValueErrorMessage
    }) : onChange === null || onChange === void 0 ? void 0 : onChange({
      value: []
    });
  };

  var handleClearSearchActionOnClick = function handleClearSearchActionOnClick(event) {
    event.stopPropagation();
    setSearchValue("");
  };

  var handleOptionOnClick = (0, _react.useCallback)(function (option) {
    handleSelectChangeValue(option);
    !multiple && closeOptions();
    setSearchValue("");
  }, [handleSelectChangeValue, closeOptions, multiple]);
  var getSelectWidth = (0, _react.useCallback)(function () {
    var _selectRef$current;

    var rect = selectRef === null || selectRef === void 0 ? void 0 : (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.getBoundingClientRect();
    return rect === null || rect === void 0 ? void 0 : rect.width;
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.select
  }, /*#__PURE__*/_react["default"].createElement(SelectContainer, {
    margin: margin,
    size: size,
    ref: ref
  }, label && /*#__PURE__*/_react["default"].createElement(Label, {
    id: selectLabelId,
    disabled: disabled,
    onClick: function onClick() {
      selectRef.current.focus();
    },
    helperText: helperText
  }, label, " ", optional && /*#__PURE__*/_react["default"].createElement(OptionalLabel, null, translatedLabels.formFields.optionalLabel)), helperText && /*#__PURE__*/_react["default"].createElement(HelperText, {
    disabled: disabled
  }, helperText), /*#__PURE__*/_react["default"].createElement(Popover.Root, {
    open: isOpen
  }, /*#__PURE__*/_react["default"].createElement(Popover.Trigger, {
    asChild: true,
    type: undefined
  }, /*#__PURE__*/_react["default"].createElement(Select, {
    id: selectId,
    disabled: disabled,
    error: error,
    onBlur: handleSelectOnBlur,
    onClick: handleSelectOnClick,
    onFocus: handleSelectOnFocus,
    onKeyDown: handleSelectOnKeyDown,
    ref: selectRef,
    tabIndex: disabled ? -1 : tabIndex,
    role: "combobox",
    "aria-controls": optionsListId,
    "aria-disabled": disabled,
    "aria-expanded": isOpen,
    "aria-haspopup": "listbox",
    "aria-labelledby": label ? selectLabelId : undefined,
    "aria-activedescendant": visualFocusIndex >= 0 ? "option-".concat(visualFocusIndex) : undefined,
    "aria-invalid": error ? true : false,
    "aria-errormessage": error ? errorId : undefined,
    "aria-required": !disabled && !optional
  }, multiple && selectedOption.length > 0 && /*#__PURE__*/_react["default"].createElement(SelectionIndicator, null, /*#__PURE__*/_react["default"].createElement(SelectionNumber, {
    disabled: disabled
  }, selectedOption.length), /*#__PURE__*/_react["default"].createElement(ClearOptionsAction, {
    disabled: disabled,
    onMouseDown: function onMouseDown(event) {
      // Avoid input to lose focus when pressed
      event.preventDefault();
    },
    onClick: handleClearOptionsActionOnClick,
    tabIndex: -1,
    title: translatedLabels.select.actionClearSelectionTitle,
    "aria-label": translatedLabels.select.actionClearSelectionTitle
  }, _Icons["default"].clear)), /*#__PURE__*/_react["default"].createElement(SearchableValueContainer, null, /*#__PURE__*/_react["default"].createElement(ValueInput, {
    name: name,
    disabled: disabled,
    value: multiple ? (value !== null && value !== void 0 ? value : innerValue).join(",") : value !== null && value !== void 0 ? value : innerValue,
    readOnly: true,
    "aria-hidden": "true"
  }), searchable && /*#__PURE__*/_react["default"].createElement(SearchInput, {
    value: searchValue,
    disabled: disabled,
    onChange: handleSearchIOnChange,
    ref: selectSearchInputRef,
    autoComplete: "nope",
    autoCorrect: "nope",
    size: 1
  }), (!searchable || searchValue === "") && (multiple ? /*#__PURE__*/_react["default"].createElement(SelectedOption, {
    disabled: disabled,
    atBackground: (value !== null && value !== void 0 ? value : innerValue).length === 0 || searchable && isOpen
  }, /*#__PURE__*/_react["default"].createElement(SelectedOptionLabel, null, selectedOption.map(function (option) {
    return option.label;
  }).join(", ")), selectedOption.length === 0 && placeholder) : /*#__PURE__*/_react["default"].createElement(SelectedOption, {
    disabled: disabled,
    atBackground: !(value !== null && value !== void 0 ? value : innerValue) || searchable && isOpen
  }, /*#__PURE__*/_react["default"].createElement(SelectedOptionLabel, null, (_selectedOption$label = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _selectedOption$label !== void 0 ? _selectedOption$label : placeholder)))), !disabled && error && /*#__PURE__*/_react["default"].createElement(ErrorIcon, null, _Icons["default"].error), searchable && searchValue.length > 0 && /*#__PURE__*/_react["default"].createElement(ClearSearchAction, {
    onMouseDown: function onMouseDown(event) {
      // Avoid input to lose focus
      event.preventDefault();
    },
    onClick: handleClearSearchActionOnClick,
    tabIndex: -1,
    title: translatedLabels.select.actionClearSearchTitle,
    "aria-label": translatedLabels.select.actionClearSearchTitle
  }, _Icons["default"].clear), /*#__PURE__*/_react["default"].createElement(CollapseIndicator, {
    disabled: disabled
  }, isOpen ? _Icons["default"].arrowUp : _Icons["default"].arrowDown))), /*#__PURE__*/_react["default"].createElement(Popover.Content, {
    sideOffset: 4,
    onOpenAutoFocus: function onOpenAutoFocus(event) {
      // Avoid select to lose focus when the list is opened
      event.preventDefault();
    },
    onCloseAutoFocus: function onCloseAutoFocus(event) {
      // Avoid select to lose focus when the list is closed
      event.preventDefault();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Listbox["default"], {
    id: optionsListId,
    currentValue: value !== null && value !== void 0 ? value : innerValue,
    options: searchable ? filteredOptions : options,
    visualFocusIndex: visualFocusIndex,
    lastOptionIndex: lastOptionIndex,
    multiple: multiple,
    optional: optional,
    optionalItem: optionalItem,
    searchable: searchable,
    handleOptionOnClick: handleOptionOnClick,
    getSelectWidth: getSelectWidth
  }))), !disabled && typeof error === "string" && /*#__PURE__*/_react["default"].createElement(Error, {
    id: errorId,
    "aria-live": error ? "assertive" : "off"
  }, error)));
});

var sizes = {
  small: "240px",
  medium: "360px",
  large: "480px",
  fillParent: "100%"
};

var calculateWidth = function calculateWidth(margin, size) {
  return size === "fillParent" ? "calc(".concat(sizes[size], " - ").concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")") : sizes[size];
};

var SelectContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n\n  width: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return calculateWidth(props.margin, props.size);
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
});

var Label = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  cursor: default;\n  ", "\n"])), function (props) {
  return props.disabled ? props.theme.disabledColor : props.theme.labelFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.labelFontSize;
}, function (props) {
  return props.theme.labelFontStyle;
}, function (props) {
  return props.theme.labelFontWeight;
}, function (props) {
  return props.theme.labelLineHeight;
}, function (props) {
  return !props.helperText && "margin-bottom: 0.25rem";
});

var OptionalLabel = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: ", ";\n"])), function (props) {
  return props.theme.optionalLabelFontWeight;
});

var HelperText = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  margin-bottom: 0.25rem;\n"])), function (props) {
  return props.disabled ? props.theme.disabledColor : props.theme.helperTextFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.helperTextFontSize;
}, function (props) {
  return props.theme.helperTextFontStyle;
}, function (props) {
  return props.theme.helperTextFontWeight;
}, function (props) {
  return props.theme.helperTextLineHeight;
});

var Select = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  position: relative;\n  align-items: center;\n  height: calc(2.5rem - 2px);\n  padding: 0 0.5rem;\n  outline: none;\n  ", ";\n  box-shadow: 0 0 0 2px transparent;\n  border-radius: 4px;\n  border: 1px solid\n    ", ";\n  ", "\n  ", ";\n\n  ", ";\n"])), function (props) {
  return props.disabled && "background-color: ".concat(props.theme.disabledInputBackgroundColor);
}, function (props) {
  return props.disabled ? props.theme.disabledInputBorderColor : props.theme.enabledInputBorderColor;
}, function (props) {
  return props.error && !props.disabled && "border-color: transparent;\n     box-shadow: 0 0 0 2px ".concat(props.theme.errorInputBorderColor, ";\n  ");
}, function (props) {
  return props.disabled ? "cursor: not-allowed;" : "cursor: pointer;";
}, function (props) {
  return !props.disabled && "\n      &:hover {\n        border-color: ".concat(props.error ? "transparent" : props.theme.hoverInputBorderColor, ";\n        ").concat(props.error && "box-shadow: 0 0 0 2px ".concat(props.theme.hoverInputErrorBorderColor, ";"), "\n      }\n      &:focus-within {\n        border-color: transparent;\n        box-shadow: 0 0 0 2px ").concat(props.theme.focusInputBorderColor, ";\n      }\n    ");
});

var SelectionIndicator = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  border: 1px solid ", ";\n  border-radius: 2px;\n  max-height: 22px;\n  width: 46px;\n"])), function (props) {
  return props.theme.selectionIndicatorBorderColor;
});

var SelectionNumber = _styledComponents["default"].span(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  user-select: none;\n  ", ";\n  border-right: 1px solid ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  ", "\n"])), function (props) {
  return !props.disabled && "background-color: ".concat(props.theme.selectionIndicatorBackgroundColor);
}, function (props) {
  return props.theme.selectionIndicatorBorderColor;
}, function (props) {
  return props.disabled ? props.theme.disabledColor : props.theme.selectionIndicatorFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.selectionIndicatorFontSize;
}, function (props) {
  return props.theme.selectionIndicatorFontStyle;
}, function (props) {
  return props.theme.selectionIndicatorFontWeight;
}, function (props) {
  return props.disabled ? "cursor: not-allowed;" : "cursor: default;";
});

var ClearOptionsAction = _styledComponents["default"].button(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  width: 23px;\n  height: 22px;\n  border: none;\n  padding: 0.25rem;\n  ", "\n  background-color: ", ";\n  color: ", ";\n\n  :focus-visible {\n    outline: none;\n  }\n  ", "\n\n  svg {\n    line-height: 18px;\n  }\n"])), function (props) {
  return props.disabled ? "cursor: not-allowed;" : "cursor: pointer;";
}, function (props) {
  return props.disabled ? "transparent" : props.theme.enabledSelectionIndicatorActionBackgroundColor;
}, function (props) {
  return props.disabled ? props.theme.disabledColor : props.theme.enabledSelectionIndicatorActionIconColor;
}, function (props) {
  return !props.disabled && "\n      &:hover {\n        background-color: ".concat(props.theme.hoverSelectionIndicatorActionBackgroundColor, ";\n        color: ").concat(props.theme.hoverSelectionIndicatorActionIconColor, ";\n      }\n      &:active {\n        background-color: ").concat(props.theme.activeSelectionIndicatorActionBackgroundColor, ";\n        color: ").concat(props.theme.activeSelectionIndicatorActionIconColor, ";\n      }\n    ");
});

var SearchableValueContainer = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  display: grid;\n  width: 100%;\n"])));

var SelectedOption = _styledComponents["default"].span(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  grid-area: 1 / 1 / 1 / 1;\n  display: inline-flex;\n  align-items: center;\n  height: calc(2.5rem - 2px);\n  padding: 0 0.5rem;\n  user-select: none;\n  overflow: hidden;\n\n  color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n"])), function (props) {
  if (props.disabled) return props.theme.disabledColor;else if (props.atBackground) return props.theme.placeholderFontColor;else return props.theme.valueFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.valueFontSize;
}, function (props) {
  return props.theme.valueFontStyle;
}, function (props) {
  return props.theme.valueFontWeight;
});

var SelectedOptionLabel = _styledComponents["default"].span(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));

var ValueInput = _styledComponents["default"].input(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  display: none;\n"])));

var SearchInput = _styledComponents["default"].input(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  grid-area: 1 / 1 / 1 / 1;\n  height: calc(2.5rem - 2px);\n  background: none;\n  border: none;\n  outline: none;\n  padding: 0 0.5rem;\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: 1.5em;\n"])), function (props) {
  return props.disabled ? props.theme.disabledColor : props.theme.valueFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.valueFontSize;
}, function (props) {
  return props.theme.valueFontStyle;
}, function (props) {
  return props.theme.valueFontWeight;
});

var ErrorIcon = _styledComponents["default"].span(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  padding: 3px;\n  height: 18px;\n  width: 18px;\n  margin-left: 0.25rem;\n  pointer-events: none;\n  color: ", ";\n\n  svg {\n    line-height: 18px;\n    font-size: 1.25rem;\n  }\n"])), function (props) {
  return props.theme.errorIconColor;
});

var Error = _styledComponents["default"].span(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2["default"])(["\n  min-height: 1.5em;\n  color: ", ";\n  font-family: ", ";\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1.5em;\n  margin-top: 0.25rem;\n"])), function (props) {
  return props.theme.errorMessageColor;
}, function (props) {
  return props.theme.fontFamily;
});

var CollapseIndicator = _styledComponents["default"].span(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  height: 16px;\n  width: 16px;\n  padding: 4px;\n  margin-left: 0.25rem;\n  color: ", ";\n"])), function (props) {
  return props.disabled ? props.theme.disabledColor : props.theme.collapseIndicatorColor;
});

var ClearSearchAction = _styledComponents["default"].button(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  height: 24px;\n  width: 24px;\n  font-size: 1rem;\n  font-family: ", ";\n  border: 1px solid transparent;\n  border-radius: 2px;\n  padding: 3px;\n  margin-left: 0.25rem;\n  background-color: ", ";\n  color: ", ";\n\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n    color: ", ";\n  }\n  svg {\n    line-height: 18px;\n  }\n"])), function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.actionBackgroundColor;
}, function (props) {
  return props.theme.actionIconColor;
}, function (props) {
  return props.theme.hoverActionBackgroundColor;
}, function (props) {
  return props.theme.hoverActionIconColor;
}, function (props) {
  return props.theme.activeActionBackgroundColor;
}, function (props) {
  return props.theme.activeActionIconColor;
});

var _default = DxcSelect;
exports["default"] = _default;